module.exports = __webpack_public_path__ + "static/media/gcdef_10033.e8f1fe96.ico";